import React from 'react'

import { Food } from '../../../core/foods'
import styles from '../../styles/modules/each-item/item-image-items.module.scss'

interface Props {
  food: Food
}

const FoodImageItems: React.FC<Props> = props => (
  <div className={styles.container}>
    <div className={styles.itemContainer}>
      <h4>フード画像</h4>
      <img
        alt="food"
        src={props.food.thumbnailImageURL}
        className={styles.image}
      />
    </div>
  </div>
)

export default FoodImageItems
